module.exports = __webpack_public_path__ + "static/media/ic_template_1.8bfb6e53.png";